module.exports = __webpack_public_path__ + "public-ui/img/gtb.d4ae7d1e.svg";